// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

/** Public block-explorer URL for an on-chain address. Mainnet only by
 *  design: on every other network (`signet`, `regtest`, …) this
 *  returns `null` and the address renders as plain text — there is no
 *  explorer we want to endorse there, and a wrong-network link is
 *  worse than none. `network` is the verifier-derived
 *  `bitcoin_network` field of the full lookup response. */
export function mempoolAddressUrlForNetwork(
  network: string | null,
  address: string,
): string | null {
  return network === 'bitcoin' ? `https://mempool.space/address/${address}` : null;
}

/** COB-507: the same mainnet-only rule for the **shared-vault** surface.
 *
 *  A separate function rather than a widened one because the two services
 *  spell the network differently and conflating them is exactly the bug this
 *  guards: the yield verifier reports the tb1 family as `signet` and mainnet as
 *  `bitcoin`, while a shared-vault contract pins `mainnet|testnet|signet|
 *  regtest` verbatim (AR-20) and verifier-shared echoes it unchanged. Matching
 *  on `'bitcoin'` here would silently never link; matching on `'mainnet'` in
 *  the yield helper would silently never link there. Mainnet only, for the same
 *  reason as above — a wrong-network explorer link is worse than none. */
export function mempoolAddressUrlForSharedNetwork(
  network: string | null,
  address: string,
): string | null {
  return network === 'mainnet' ? `https://mempool.space/address/${address}` : null;
}
